import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { Badge, Switch } from '@lib/components'
import { ProjectActions } from '@octopus-do/octopus-project-core'
import { Dollar as EstimateIcon } from '@octopus-do/octopus-storybook/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

type Props = {
  disabled?: boolean
}

export const EstimateMode: React.FC<Props> = ({ disabled = false }) => {
  const dispatch = useDispatch()

  // The switch reflects what the toolbar actually does, which for an untouched
  // project means "does it already have estimate data" rather than the raw
  // (undefined) flag. Flipping it always writes an explicit true/false.
  const estimateModeToggle = useSelector(
    migrationProjectSelector.getProjectEstimateIconVisible
  )

  const { hasAccess, hasNotAvailableAccessBadge, badgeType } = useProjectAccess(
    PROJECT_SETTINGS_PERMISSION.ENABLE_ESTIMATE
  )

  const handleOnChange = (value: boolean) => {
    dispatch(
      commitProjectRequest(
        ProjectActions.settings.changeEstimateMode({ estimateMode: value })
      )
    )
  }

  const handleBadgeClick = () => {
    dispatch(openModal(MODAL_UPGRADE_PLAN))
  }

  return (
    <div className={clsJoin(css.estimate_mod, !hasAccess && css.disabled)}>
      <EstimateIcon />
      <div className={css.estimate_mod_text}>Estimate</div>

      <div className={css.estimate_mod_switch}>
        {!hasNotAvailableAccessBadge ? (
          <Switch
            mode="thin"
            checked={estimateModeToggle}
            disabled={!hasAccess || disabled}
            onChange={handleOnChange}
          />
        ) : (
          <Badge type={badgeType} onClick={handleBadgeClick} />
        )}
      </div>
    </div>
  )
}
